export const styles = theme => ({
  tableRow: {
    height: 28,
  },
  tableCell: {
    paddingLeft: theme.spacing.unit,
    paddingRight: theme.spacing.unit
  },
  sourceInput: {
    padding: 0,
    width: 35,
    fontSize: '0.8125rem'
  },
})



// WEBPACK FOOTER //
// ./src/components/Prices/components/PricesBodyRow/styles.js